import React, { useState } from "react";

import {
  Accordion,
  BulletList,
  BulletListType,
} from "@at/design-system-patterns";
import { getChannelSingular } from "@at/formatter-utils";
import { Channel } from "@at/sauron-platform-core";

import { carsFaqsContent, vansFaqsContent } from "./leasing-about-modal.copy";
import * as Styled from "./leasing-about-modal.styles";
import { useChannel } from "../../../../utils/hooks/use-channel";
import { useTracking } from "../../../../utils/tracking/use-tracking";

export const WhatIsLeasingModalContent = () => {
  const { trackEvent } = useTracking();
  const [videoVisible, setVideoVisible] = useState(false);
  const channel = useChannel();
  const channelSingular = getChannelSingular(channel);
  const isChannelCars = channel === Channel.cars;

  const faqsContent =
    channel === Channel.cars ? carsFaqsContent : vansFaqsContent;
  const videoReference = "o8Je7YV3KtE";

  const videoImageLink = `https://www.autotrader.co.uk/you-tube/image/xl/${videoReference}`;
  const videoEmbedSrc = `https://www.youtube.com/embed/${videoReference}?rel=0&autoplay=1`;

  return (
    <Styled.Content>
      <Styled.Title>What is {channelSingular} leasing?</Styled.Title>

      {isChannelCars && (
        <Styled.VideoWrapper>
          {(!videoVisible && (
            <Styled.Thumbnail>
              <Styled.ThumbnailImage
                src={videoImageLink}
                alt="Video placeholder"
                shouldLazyLoad
              />
              <Styled.PlayButton
                aria-label="Watch what is leasing video"
                onClick={() => {
                  setVideoVisible(true);
                  trackEvent({ trackingLabel: "leasing-modal-video-play" });
                }}
              />
            </Styled.Thumbnail>
          )) || (
            <Styled.Video
              title="Video"
              width={16}
              height={9}
              src={videoEmbedSrc}
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          )}
        </Styled.VideoWrapper>
      )}
      {isChannelCars ? (
        <Styled.Body>
          In this video, we cover the basics of car leasing, including:
          <BulletList
            items={[
              "How car leasing works",
              "Your car lease payment options",
              "Car lease maintenance",
              `Owning a car and more`,
            ]}
            listType={BulletListType.STANDARD}
          />
          Wondering if a car lease would suit you? Watch our new video or visit
          our <a href={"/cars/leasing"}>leasing hub</a> for more guides.
        </Styled.Body>
      ) : (
        <>
          <Styled.Body isVans={!isChannelCars}>
            {" "}
            Here&apos;s everything you need to know about van leasing, so you
            can decide if leasing works for you.
          </Styled.Body>
        </>
      )}

      {isChannelCars && (
        <Styled.FAQsTitle>Your questions answered</Styled.FAQsTitle>
      )}
      <Accordion items={faqsContent} />
    </Styled.Content>
  );
};
